<template>
  <el-dialog
    title="分类名称"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    user: Object,
    roles: Array
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '分类名',
          field: 'content',
          type: 'text',
          rules: [{ required: true, message: '分类名必填', trigger: 'blur' }]
        }
      ],

      formBtns: [
        {
          content: '保存',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {},
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
      console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
